export default{
  "1": "المنتجات في غير محلها",
  "2": "اعد الامر",
  "3": "فشل الاستلام",
  "4": "أسباب أخرى",
  order: {
    cancel: "الغاء الطلب",
    payment: "ادفع الآن",
    confirm: "تأكيد استلام",
    remind: "تذكير بالشحن",
    return: "طلب استرداد المنتج",
    evaluate: "مراجعة الآن",
    logistics: "عرض الخدمات اللوجستية",
    noRefund: "غير معاد",
    refunding: "جاري استرداد الأموال",
    refundSuccess: "نجح رد الأموال",
    refundFail: "فشل الاسترداد",
    remindTitle: "تذكير بالشحن",
}, 
cancelOrderMap: {
  0: "لا اريدها.",
  1: "المنتج في غير مكانه",
  2: "كرر الطلب",
  3: "فشل الاستلام",
  4: "أسباب أخرى",
},
"获取验证码": "احصل على رمز التحقق",
  "请输入验证码": "الرجاء إدخال رمز التحقق",
  "验证码": "رمز التحقق",
  "发送": "ارسال",
  "已发送，请注意查收": "تم الإرسال، يرجى التحقق من الرسائل المرسلة",
  "暂无数据": "لايوجد بيانات",
  "加载中": "تحميل",
  "电商批发商场": "مول بالجملة",
  "热销推荐": "صفقات ساخنة",
  "用户未发表评论": "لم يترك المستخدمون أي تعليقات",
  "请输入关键字搜索": "الرجاء إدخال الكلمة للبحث",
  "请输入完整的支付密码!": "الرجاء إدخال كلمة المرور الكاملة للدفع!",
  "subOrder": "يُقدِّم",
  "-连接已建立-": "- تم إنشاء الاتصال-",
  ",才可提币": "، ومن ثم يمكن سحب النقود.",
  "[code]值错误": "قيمة [كود] غير صحيحة",
  "[symbol]参数为空": "المعلمة [الرمز] فارغة",
  "goodsFreightTips1": "1. صيغة سعر الشحن للشحن: معدل الشحن = رسوم الإرسال + المسافة + رسوم التسليم",
  "creditQuotaINFO": "100،000 إلى 30،000،000 بحد مرن وبدون قيود ، مع مدة قرض تصل إلى سنة واحدة كحد أقصى.",
  "authentic": "أصلي 100٪",
  "homeIconTips1": "أصلي 100٪",
  "goodsFreightTips2": "2. في حالة عدم استيفاء شروط البريد ، يتم فرض تكلفة الشحن وفقًا للظروف الفعلية.",
  "goodsFreightTips3": "3. حق التفسير النهائي ملك للمنصة.",
  "dayReturns7": "عودة لمدة 7 أيام",
  "homeIconTips2": "عودة لمدة 7 أيام",
  "homeIconTips4": "دفع امن",
  "safe": "آمن وخالي من القلق",
  "safePayment": "دفع امن",
  "homeDownloadtips4": "تنزيل لنظام Android",
  "keep": "يحافظ على",
  "saveQr": "حفظ رمز الاستجابة السريعة",
  "payPal": "باي بال",
  "coinBlock": "عملة",
  "validatorRequire": "لا يمكن أن تكون الحقول المطلوبة فارغة",
  "edit": "حررت بواسطة",
  "markDefaultAddress": "ضع علامة كعنوان شحن افتراضي",
  "不能为空": "لا يمكن أن تكون فارغة",
  "cancelOrder2": "لا تعجبك ، لا تريدها",
  "contactUs1": "إذا كنت لا ترغب في اقتراض أموال من أصدقائك ، فيرجى الاتصال بنا.",
  "不在交易时段": "خارج جلسة التداول",
  "不在可提现时间内": "خارج فترة الانسحاب",
  "猜你喜欢": "أعتقد أنك تحب ذلك",
  "paramError": "خطأ في المعلمة",
  "参数错误": "خطأ في المعلمة",
  "参数异常，消息获取失败": "خطأ في المعلمة. فشل في الحصول على الرسالة",
  "Operate": "عملية",
  "operationSuccess": "نجحت العملية",
  "操作成功": "نجحت العملية",
  "操作类型不能小于0": "لا يمكن أن يكون نوع العملية أقل من 0",
  "操作类型不是整数": "نوع العملية ليس عددًا صحيحًا",
  "操作类型为空": "نوع العملية فارغ",
  "view": "منظر",
  "Checkorder": "مشاهدة الطلب",
  "logistics": "مشاهدة ملف Logistics",
  "CheckDetails": "عرض التفاصيل",
  "lowOpinion": "تقييمات سيئة",
  "产品不存在": "المنتج غير موجود",
  "产品剩余数量不足": "الكمية المتبقية من المنتج غير كافية",
  "interest": "استحقاق الفائدة",
  "dealSuccess": "ناجح",
  "successTips": "ناجح",
  "beSeller": "كن بائعا",
  "homeBannertips1": "كن بائعا",
  "承兑商不存在": "المتقبل غير موجود",
  "orderCity": "مدينة",
  "city": "مدينة",
  "程序错误": "خطأ في البرنامج",
  "持有币种不足": "لا يوجد تمويل كاف",
  "recharge": "إيداع",
  "rechargeSuccessful": "نجح الإيداع",
  "rechargeAddress": "عنوان الإيداع",
  "rechargeMethod": "وضع الإيداع",
  "rechargeRecord": "سجل الإيداع",
  "充值价值不得大于最大限额": "لا يمكن أن يتجاوز مبلغ الإيداع الحد الأقصى للنطاق",
  "充值价值不得小于最小限额": "لا يمكن أن يكون مبلغ الإيداع أقل من نطاق الحد الأدنى",
  "充值金额不能小于1": "لا يمكن أن يكون مبلغ الإيداع أقل من 1 (بما في ذلك رقمين عشريين)",
  "充值链错误": "خطأ في رابط الإيداع",
  "rechargeNum": "قيمة الايداع",
  "充值数量不能小于等于0": "لا يمكن أن يكون مبلغ الإيداع أقل من أو يساوي 0",
  "rechargeTips": "ملاحظة الإيداع: يرجى ملء مبلغ التحويل بشكل صحيح. خلاف ذلك ، قد يفشل النظام في اجتياز الموافقة ويؤثر على تقدم إعادة الشحن.",
  "dealing": "تحت المعالجة",
  "processing": "تحت المعالجة",
  "ship": "قارب",
  "creditText1": "قروض البدء هي لتجنب متاعب اقتراض المال",
  "businessloan": "طلب قرض بدء التشغيل",
  "存在不同杠杆的持仓单": "هناك خيارات مختلفة للرافعة المالية",
  "cancelOrder7": "هناك مشكلة كبيرة",
  "存在重复的角色名称": "اسم دور مكرر",
  "大于最大采购数量": "أكثر من الحد الأقصى لمبلغ الشراء",
  "代理层级错误": "خطأ الوكيل",
  "delivered": "شحنة معلقة",
  "pendingPayment": "في انتظار الدفع",
  "待付款的订单无法放行": "غير قادر على تحرير الدفع المعلق",
  "comment": "للمراجعة",
  "receipt": "ليتم الاستلام",
  "pending": "في انتظار الدفع",
  "loanHistory": "سجل القرض",
  "rates": "معدل الفائدة على القرض",
  "term": "شروط القرض",
  "application": "طلب القرض",
  "creditWorry": "قرض بدون قلق",
  "orderUnitprice": "سعر الوحدة",
  "当前地址格式错误": "العنوان الحالي بتنسيق خاطئ",
  "当前订单不为待付款状态，无法取消": "الطلب الحالي ليس في حالة معلقة. لا يمكن إلغاؤها.",
  "当前还需交易": "الصفقة لا تزال مطلوبة",
  "currentRate": "سعر الصرف الحالي",
  "sure": "بالطبع",
  "当日才可申购": "متاح فقط للشراء في نفس اليوم",
  "当日可提现次数不足": "عدد غير كافٍ من عمليات السحب النقدي في اليوم",
  "receivedAddress": "عنوان المستلم",
  "orderAddress": "عنوان",
  "登陆密码不符合设定": "كلمة مرور خاطئة",
  "登陆密码长度不符合设定": "كلمة مرور خاطئة",
  "login": "تسجيل الدخول",
  "loginIn": "تسجيل الدخول",
  "signIn": "تسجيل الدخول",
  "loginSuccess": "نجح",
  "登录过期，请重新登录": "انتهت الجلسة. الرجاد الدخول على الحساب من جديد",
  "LoginPassword": "كلمة سر الدخول",
  "登录密码必须6-12位": "يجب أن تتكون كلمة المرور من 6 إلى 12 حرفًا",
  "登录密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "登录失败": "فشل في تسجيل الدخول",
  "clickUpload": "انقر للتحميل",
  "phoneNumber": "رقم الهاتف المحمول",
  "电话号码已绑定": "رقم الهاتف المحمول مرتبط بالفعل",
  "电话号码已绑定其他用户": "رقم الهاتف المحمول مرتبط بالفعل بمستخدم آخر",
  "email": "بريد إلكتروني",
  "shopCollection": "أضف المتجر إلى المفضلة",
  "订单": "طلب",
  "trackOrder": "طلب",
  "订单不存在": "الطلب غير موجود",
  "orderTrack": "استعلام عن الطلب",
  "serialNumber": "رقم الطلب",
  "orderSummary": "إجمالي الطلبات",
  "cancelOrderSuccess": "الطلبات الملغاة",
  "订单退款成功": "الطلبات المعادة",
  "订单退款失败": "الطلبات الفاشلة للاسترداد",
  "orderDetails": "تفاصيل الطلب",
  "orderInfo": "معلومات الطلب",
  "订单已签收": "تم استلام الطلب",
  "订单已取消": "تم إلغاء الطلب",
  "订单已取消，无法放行": "تم إلغاء الطلب ولا يمكن تحريره",
  "订单已取消，原因:超时自动取消订单": "تم إلغاء الطلب تلقائيًا بسبب انتهاء فترة الانتظار",
  "订单已取消，原因:手动发起取消订单": "تم إلغاء الطلب يدويًا",
  "订单已完成": "تم الانتهاء من الطلب",
  "订单已完成，无法放行": "تم إكمال الطلب ولا يمكن تحريره",
  "moneyOrderStatus": "حالة الطلب",
  "orderPrefix": "إجمالي الطلبات",
  "subscription": "يشترك",
  "aboutText2": "الحد الأقصى: 100،000-30،000،000 ، طريقة سداد مرنة بفائدة منخفضة ، بدون رسوم مقدمة ، قرض عبر الإنترنت ، بدون مكالمة هاتفية للتحقق ، معلومات سرية ، وإقراض في نفس اليوم.",
  "additional": "أكثر",
  "evaluateOrderSuccess": "نجحت المراجعة",
  "goodsShip": "شحنة",
  "发起退款申请": "طلب استرداد",
  "send": "يرسل",
  "发现新版本，请升级到最新版本": "تم العثور على إصدار جديد ، يرجى الترقية إلى أحدث إصدار",
  "visitStore": "قم بزيارة المعرض او المتجر",
  "collAccount": "طريقة القرض",
  "loanMethod": "طريقة القرض",
  "classification": "فئة",
  "服务器错误": "خطأ في الخادم",
  "服务器错误(500)": "خطأ في الخادم (500)",
  "servicePolicy": "سياسة الخدمة",
  "PaymentOrder": "أمر دفع",
  "uploadTips": "إثبات الدفع (تحميل لقطة شاشة لتفاصيل الدفع)",
  "copy": "ينسخ",
  "copySuccess": "تم النسخ بنجاح",
  "该产品未上架": "هذا المنتج غير مدرج",
  "该产品已上市，无法购买": "هذا المنتج معروض في السوق ولا يمكن شراؤه",
  "该订单已取消": "تم الغاء هذا الطلب",
  "remindRepeat": "تم تذكير هذا الطلب",
  "该广告剩余数量不足": "العدد المتبقي من الإعلانات المتبقية غير كاف",
  "该基金尚未开放购买": "لم يتم فتح الصندوق للشراء",
  "该基金尚已封闭": "تم إغلاق الصندوق",
  "productAvailable": "تمت إزالة هذا المنتج",
  "该邮箱已被订阅": "تم بالفعل الاشتراك في هذا البريد الإلكتروني",
  "notOpen": "طريقة الدفع هذه ليست مفتوحة لمنطقتك",
  "格式有误:充值金额不能小于1(包含俩位小数)": "التنسيق خاطئ: لا يمكن أن يكون مبلغ الإيداع أقل من 1 (بما في ذلك رقمين عشريين)",
  "userCenter": "المركز الشخصي",
  "Item": "أغراض)",
  "跟单倍数输入错误": "خطأ في الإدخال المتعدد",
  "跟单参数输入错误": "خطأ في الإدخال المتعدد",
  "more": "أكثر",
  "更新提醒": "تذكير التحديث",
  "工作地址不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "homeBannertips2": "إجمالي العمولة",
  "orderTotal": "المجموع",
  "buyHistory": "سجلات الشراء",
  "购买矿机时间不得低于托管订单剩余时间": "يجب ألا يقل وقت شراء آلات التعدين عن الوقت المتبقي لأمر الاستضافة",
  "purchageHistory": "تاريخ شراء",
  "addCartMessageFaild": "المنتج موجود بالفعل في عربة التسوق الخاصة بك",
  "fixedRate": "معدل فائدة ثابت",
  "aboutUs": "معلومات عنا",
  "about": "معلومات عنا",
  "followers": "يتبع",
  "当前余额": "الرصيد الحالي",
  备注: "ملاحظات",
  "followedSuccess": "نجح",
  "myFollowedShops": "اتبع المتجر",
  "广告不存在": "الإعلان غير موجود",
  "广告已下架": "تمت إزالة الإعلان",
  "orderSpecification": "تخصيص",
  "countryOf": "جنسية",
  "areaCode": "كود المنطقة الدولية",
  "App下载(买家端)": "تنزيل التطبيق (المشتري)",
  "App下载(卖家端)": "تنزيل التطبيق (البائع)",
  "orderNation": "دولة",
  "nation": "دولة",
  "repayment": "السداد",
  "repay": "طريقة السداد",
  "reAmount": "مبلغ السداد",
  "cycle": "دورة السداد",
  "loginTips": "ليس لديك رقم حساب؟",
  "noAccount": "ليس لديك رقم حساب؟",
  "NoProductSelected": "لم يتم اختيار أي منتج حتى الآن",
  "shipping": "شحن",
  "highOpinion": "مراجعات جيدة",
  "favorableRate": "معدل التقييمات الجيدة",
  "myPraiseRate": "معدل التقييمات الجيدة",
  "totalNum": "المجموع",
  "partner": "الموردين التعاونيين",
  "partnersTit": "شريك - منصة الإقراض عبر الإنترنت",
  "BackHome": "العودة إلى الصفحة الرئيسية",
  "or": "أو",
  "freight": "شحن",
  "orderFreight": "شحن",
  "getCoupons": "احصل على المزيد من القسائم",
  "基金剩余购买金额不足": "مبلغ الشراء المتبقي للصندوق غير كاف",
  "quickLoan": "قرض سريع",
  "records": "سِجِلّ",
  "proceed": "يكمل",
  "storeSeachTips3": "بيت",
  "家庭地址不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "cancelOrder4": "علامة تجارية مزيفة",
  "price": "سعر",
  "piece": "قطع",
  "transactionPassword": "عملية كلمة المرور",
  "交易员不存在": "البائع غير موجود",
  "交易员不能跟随自己": "لا يمكن للبائعين اتباع أنفسهم",
  "交易员跟随人数已满": "عدد المتداولين التاليين ممتلئ",
  "交易员未开启带单": "لم يفتح البائع الطلب",
  "交易员无法跟随另一个交易员": "لا يمكن للبائع متابعة بائع آخر",
  "角色被用户关联，不可删除": "الدور مرتبط بالمستخدم. لا يمكن حذفه",
  "角色不存在": "الدور غير موجود",
  "receiver": "المتلقي",
  "financial": "حل مشاكلك المالية",
  "successLoan": "انتهت عملية الإقراض بنجاح",
  "borrow": "فشلت عملية الإقراض في الانتهاء",
  "loanAgree": "اتفاقية قرض",
  "amount": "كمية",
  "金额不在购买区间": "المبلغ ليس في نطاق الشراء",
  "validatorMaxNumber": "المبلغ يتجاوز نطاق الحد",
  "金额错误": "مقدار الخطأ",
  "validatorChineseAndEnglish": "يتم دعم اللغات الصينية والإنجليزية فقط ؛ محتوى الإدخال هو 8-64 حرفًا",
  "oldPassword": "كلمة المرور القديمة",
  "旧密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "旧密码不正确": "كلمة السر القديمة غير صحيحة",
  "可平仓合约张数不足": "عدد غير كافٍ من عقود المركز المغلقة",
  "service": "خدمة الزبائن",
  "custService": "خدمة الزبائن",
  "homeDownloadtips1": "متجر جملة للتجارة الإلكترونية عبر الحدود",
  "矿机不存在": "آلة التعدين غير موجودة",
  "矿机未解锁，无法购买": "آلة التعدين مقفلة ولا يمكن شراؤها.",
  "From": "من",
  "历史基金无法购买": "لا يمكن شراء الأموال السابقة",
  "historySearch": "البحث في التاريخ",
  "payment": "ادفع الآن",
  "buyNow": "شراء الآن",
  "homeBannerbtn": "نضم الان",
  "evaluate": "مراجعة الآن",
  "连续输入错误三次，请3分钟后再试": "حدث إدخال غير صالح ثلاث مرات على التوالي. يرجى المحاولة مرة أخرى بعد 3 دقائق",
  "contactUs": "اتصل بنا",
  "twoPawword": "كلمات السر لا تتطابق",
  "creditQuota": "نطاق حد مرن",
  "retailPrice": "سعر التجزئة",
  "领取成功": "تم الاستلام بنجاح",
  "pageviews": "عدد المشاهدات",
  "myPageviews": "عدد المشاهدات",
  "buyRules": "قواعد المشتري",
  "买入金额需要在区间内": "يجب أن يكون مبلغ الشراء في النطاق",
  "卖方无法取消该订单": "لا يمكن للبائع إلغاء الطلب",
  "cancelOrder3": "البائع شحن البضائع الخاطئة",
  "sellerRules": "سياسة البائع",
  "noDataFound": "لاتوجد بيانات",
  "没有找到用户": "لم يتم العثور على المستخدم",
  "dailyNewArrival": "الصفقات اليومية",
  "password": "كلمة المرور",
  "密码必须6-12位": "يجب أن تتكون كلمة المرور من 6 إلى 12 حرفًا",
  "密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "密码不正确": "كلمة مرور خاطئة",
  "wrongPassword": "تجاوز عدد المحاولات 3 مرات. ارجوك حاول مرة أخرى غدا",
  "validatorPassword": "يجب أن تتكون كلمة المرور من 6-12 حرفًا ورقمًا (تحتوي على أحرف خاصة)",
  "goodsFreeShipping": "شحن مجاني",
  "orderName": "اسم",
  "defaultAddress": "العنوان الافتراضي",
  "noCartTips": "سلة التسوق الخاصة بك فارغة. ابدأ التسوق",
  "notLogin": "لم تسجل الدخول بعد.",
  "unSelectedProduct": "لم تقم بتحديد أي منتج",
  "evaluationUploading": "لا يزال يتم تحميل الصور. الرجاء معاودة المحاولة في وقت لاحق",
  "您当前可分配额度不足": "الحد الحالي للتخصيص الخاص بك لا يكفي",
  "yourEmail": "عنوان بريدك  الإلكتروني",
  "您没有符合条件的收款方式": "ليس لديك طريقة دفع مؤهلة",
  "您已存在订单": "لديك طلب",
  "您已购买过体验矿机,不得重复购买": "لقد اشتريت بالفعل آلة التعدين ذات الخبرة. لا تشتريه مرة أخرى",
  "photoExample": "مثال الصورة",
  "homeDownloadtips2": "ماركات للبيع",
  "Evaluate": "المراجعات",
  "evaluateOrder": "التعليقات بالصور",
  "evaluateInput": "التعليقات بالصور",
  "homeDownloadtips5": "تنزيل لـ Apple",
  "cancelOrder9": "أسباب أخرى",
  "businessPhone": "رقم الاتصال بالمتجر",
  "businessEmail": "البريد الإلكتروني للشركة",
  "walletHistory": "محفوظات المحفظة",
  "亲属地址不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "亲属电话不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "亲属关系不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "亲属姓名不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "empty": "فارغ",
  "evaluateOrderPlaceholder": "الرجاء مراجعة المنتج",
  "checkAgreement": "الرجاء قبول الاتفاقية!",
  "请检查网络连接": "يرجى التحقق من اتصالك بالشبكة",
  "returnDetailTips": "يرجى إعطاء مراجعة عن المنتج",
  "switchLang": "يرجى التبديل إلى لغة أخرى للتحقق",
  "请切换其他语言后查看": "يرجى التبديل إلى لغة أخرى للتحقق",
  "请上传图片": "الرجاء تحميل الصور",
  "uploadPhoto": "الرجاء تحميل الصور",
  "请稍后再试": "الرجاء معاودة المحاولة في وقت لاحق",
  "请稍后重试": "الرجاء معاودة المحاولة في وقت لاحق",
  "pleaseSetLoginPassword": "الرجاء إدخال كلمة مرور تسجيل الدخول",
  "pleaseSetMobileNumber": "الرجاء إدخال رقم الهاتف المحمول",
  "pleaseEnterPhoneNumer": "الرجاء إدخال رقم الهاتف المحمول",
  "plaeseEnterInvitaionCode": "الرجاء إدخال رمز الدعوة",
  "pleaseEnterEmail": "الرجاء إدخال البريد الإلكتروني",
  "enterTips": "تفضل",
  "pleaseInput": "تفضل",
  "validatorFourMoreNumber": "الرجاء إدخال أكثر من 4 أحرف",
  "pleaseValidPostCode": "الرجاء إدخال أكثر من 4 أحرف",
  "validatorSixNumber": "الرجاء إدخال 6 أحرف",
  "请输入充值币种": "الرجاء إدخال عملة الإيداع",
  "plaseEnterRechargeAddress": "الرجاء إدخال عنوان الإيداع",
  "pleaseEnterAmount": "الرجاء إدخال مبلغ الإيداع",
  "pleaseInputCorrectNumber": "الرجاء إدخال رقم أكبر من 0",
  "pleaseEnterAddress": "الرجاء إدخال العنوان",
  "headerSearchTips": "الرجاء إدخال الكلمة للبحث",
  "pleaseEnterOldPassword": "الرجاء إدخال كلمة المرور القديمة",
  "pleaseEnterPassword": "الرجاء إدخال كلمة المرور",
  "请输入内容": "الرجاء إدخال المحتوى",
  "plaseeENterConfirmPassword": "الرجاء إدخال كلمة المرور للتأكيد",
  "pleaseEnterQuantity": "الرجاء إدخال المبلغ",
  "请输入搜索关键字": "الرجاء إدخال الكلمة للبحث",
  "withdrawInputTips": "الرجاء إدخال عنوان السحب",
  "plaseeEnterNewPassword": "الرجاء إدخال كلمة المرور الجديدة",
  "yourName": "الرجاء إدخال الاسم",
  "pleaseEnterAccount": "الرجاء إدخال رقم الحساب",
  "请输入正确的货币数量": "الرجاء إدخال المبلغ الصحيح",
  "请输入正确的金额": "الرجاء إدخال المبلغ الصحيح",
  "validatorPhone": "الرجاء إدخال رقم الهاتف المحمول الصحيح",
  "pleaseValidPhone": "الرجاء إدخال رقم الهاتف المحمول الصحيح",
  "请输入正确的数量": "الرجاء إدخال المبلغ الصحيح",
  "inpuEmailErro": "الرجاء إدخال عنوان البريد الإلكتروني الصحيح",
  "pleaseValidEmail": "الرجاء إدخال عنوان البريد الإلكتروني الصحيح",
  "validatorEmail": "الرجاء إدخال البريد الإلكتروني بالتنسيق الصحيح",
  "请输入正确的质押金额": "الرجاء إدخال مبلغ التعهد الصحيح",
  "请输入正确的质押天数": "الرجاء إدخال العدد الصحيح لأيام التعهد",
  "pleaseCorrectAddress": "الرجاء إدخال عنوان السحب الصحيح",
  "请填写正确的电话号码": "الرجاء إدخال رقم الهاتف المحمول الصحيح",
  "请填写正确的验证码": "الرجاء إدخال رمز التحقق الصحيح",
  "mailboxCheck": "الرجاء إدخال عنوان البريد الإلكتروني الصحيح",
  "请填写正确的邮箱地址": "الرجاء إدخال عنوان البريد الإلكتروني الصحيح",
  "请先绑定谷歌验证器": "الرجاء ربط Google Authenticator أولاً",
  "请先添加收款方式": "الرجاء إضافة طريقة الدفع أولاً",
  "请先通过高级认证": "يرجى تمرير الشهادة المتقدمة أولاً",
  "cancelOrderTitle": "الرجاء تحديد سبب إلغاء الطلب",
  "selectCountry": "الرجاء تحديد الجنسية",
  "请选择买卖方式": "الرجاء تحديد طريقة الدفع",
  "selectPeriod": "الرجاء تحديد فترة",
  "returnOrderTitle": "الرجاء تحديد سبب الإرجاع",
  "请选择正确的币种": "الرجاء تحديد العملة الصحيحة",
  "请重新登录": "الرجاد الدخول على الحساب من جديد",
  "blockchainNetwork": "شبكة بلوكشين",
  "渠道未开通": "القناة غير مفتوحة",
  "Cancel": "يلغي",
  "取消": "يلغي",
  "cancelSuccess": "تم الإلغاء بنجاح",
  "cancelOrder": "الغاء الطلب",
  "cancel": "الغاء الطلب",
  "CancelOrder": "الغاء الطلب",
  "myUnfollow": "الغاء المتابعة",
  "cancelReason": "سبب الإلغاء",
  "all": "مشاهدة الكل",
  "AllProducts": "جميع المنتجات",
  "btnSure": "يتأكد",
  "确认": "يؤكد",
  "entRepay": "تأكيد الدفع",
  "confirmPayPaw": "قم بتأكيد كلمة المرور الخاصة بالمعاملة",
  "confirmPassword": "تأكيد كلمة المرور",
  "delAllHistoryRecord": "هل أنت متأكد أنك تريد حذف كافة سجلات التاريخ؟",
  "confirm": "تأكيد استلام",
  "date": "تاريخ",
  "scanAndDown": "امسح رمز الاستجابة السريعة لتنزيل التطبيق",
  "homeDownloadtips6": "امسح رمز الاستجابة السريعة لتنزيل التطبيق",
  "delete": "يمسح",
  "sellerPanelLogin": "تسجيل دخول البائع",
  "merchantSettled": "شراكة",
  "sellerZone": "منطقة التاجر",
  "商家已确认，已进入备货状态": "تم تأكيد البائع وبدأ عملية التخزين",
  "commodity": "منتج",
  "orderCommodity": "منتج",
  "commodityCollection": "مجموعة المنتج",
  "productDescription": "وصف المنتج",
  "myCommodityCollection": "المنتجات المفضلة",
  "goodsNumber": "كمية المنتجات",
  "goodsShipTips": "بعد تقديم الطلب ، سيتم شحنه في غضون 24 ساعة. يعتمد وقت الشحن على الخدمات اللوجستية وقد يطول. يرجى الانتباه إلى المعلومات اللوجستية أو الاتصال بخدمة العملاء",
  "productInfo": "معلومات المنتج",
  "uploadSuccess": "تم الرفع بنجاح",
  "uploadError": "فشل التحميل ، يرجى المحاولة مرة أخرى",
  "uploading": "جارٍ التحميل ...",
  "upNew": "منتجات جديدة",
  "previous": "خطوة سابقة",
  "prevPage": "الصفحة السابقة",
  "cancelOrder5": "أقل شحنة ، شحنة فائتة",
  "desc": "تعيين كعنوان افتراضي",
  "setAsTheDefaultAddress": "تعيين كعنوان افتراضي",
  "setUp": "يثبت",
  "setSuccess": "نجح الإعداد",
  "setUpPayPaw": "قم بتعيين كلمة مرور المعاملة",
  "setPassword": "ضبط كلمة السر",
  "申购数量错误": "مبلغ الشراء خاطئ",
  "申请成功": "نجح",
  "applyLoan": "التقدم بطلب للحصول على قرض",
  "applicationAmount": "الكمية المطلوبة",
  "noSmaller": "لا يمكن أن يكون المبلغ المطلوب أقل من",
  "nomax": "لا يمكن أن يتجاوز المبلغ المطلوب",
  "applicant": "طالب وظيفة",
  "applicantDate": "تاريخ التقديم",
  "return": "طلب استرداد المنتج",
  "applicantIn": "التطبيق قيد التقدم",
  "身份证已实名过!": "تم التحقق من بطاقة الهوية!",
  "审核已通过": "موافقة",
  "审核中": "قيد المراجعة",
  "state": "المقاطعة / الولاية / المنطقة",
  "dealFail": "فشل",
  "fail": "فشل",
  "orderTime": "وقت",
  "time": "وقت",
  "ActualLedger": "تلقى الفعلي",
  "actualAccount": "حساب حقيقي",
  "实名认证未通过，无法进行高级认证": "المصادقة فشلت؛ غير قادر على أداء المصادقة المتقدمة",
  "confirmReceiveGoods": "تأكيد استلام المنتج",
  "collect": "المفضلة",
  "collectionSuccess": "تمت الإضافة إلى المفضلة بنجاح",
  "wishlist": "المنتجات المفضلة",
  "cancelOrder6": "استلم المنتج التالف",
  "desc5": "عنوان الشحن خاطئ؟ اتصال",
  "consigneeName": "اسم المستلم",
  "shippingAddress": "عنوان المستلم",
  "pleaseAddShippingAddress": "الرجاء إضافة عنوان الشحن أولاً",
  "收款方输入错误": "خطأ في إدخال البيانات",
  '购物车还没有商品': "سلة التسوق فارغة",
  '去购物': "تسوق",
  "mobile": "رقم المحمول",
  "mobilePhone": "رقم الهاتف المحمول",
  "handleFee": "تكلفة الخدمة",
  "handlingFee": "تكلفة الخدمة",
  "home": "بيت",
  "授权状态未成功": "فشل حالة التفويض",
  "pleaseSetAreaCode": "أدخل اسم الدولة ورمز المنطقة للبحث",
  "searchCountry": "أدخل اسم الدولة ورمز المنطقة للبحث",
  "desc3": "أدخل كلمة المرور الخاصة بالمعاملة",
  "desc4": "أدخل كلمة مرور المعاملة الخاصة بك",
  "赎回状态异常": "حالة الاسترداد غير طبيعية",
  "quantity": "كمية",
  "orderAmount": "كمية",
  "orderQuantity": "كمية",
  "inputNum": "أعداد",
  "orderTax": "ضريبة",
  "orderFee": "الضرائب",
  "tax": "تحصيل الضرائب",
  "delivery": "التسليم والتحصيل",
  "storeSeach": "ابحث عن المنتج في هذا المتجر",
  "search": "يبحث",
  "所选汇率不存在": "سعر الصرف المحدد غير موجود",
  "allProduct": "جميع المنتجات",
  "提币数量不能小于等于0": "لا يمكن أن يكون المبلغ المسحوب أقل من أو يساوي 0",
  "creditText2": "تقديم قروض بدء التشغيل وخدمات دوران رأس المال",
  "returnOrderSuccess": "تم الإرسال بنجاح",
  "Submitareview": "إرسال المراجعات",
  "submitApplica": "تقديم الطلب",
  "提交失败": "فشل التقديم",
  "提交失败，当前有未处理订单": "فشل التقديم. هناك أوامر مفتوحة حاليا",
  "hint": "نصيحة",
  "提示": "نصيحة",
  "withdraw": "ينسحب",
  "提现不得大于限额": "لا يمكن أن يكون السحب النقدي أكبر من الحد",
  "提现不得小于限额": "لا يمكن أن يكون السحب النقدي أقل من الحد",
  "withdrawSuccess": "تم إرسال الطلبات بنجاح",
  "withdrawAddress": "عنوان الانسحاب",
  "withdrawRecord": "سجل الانسحاب",
  "withdrawNum": "كمية السحب",
  "tipsRemindsSuccess": "نجح التذكير",
  "remindSuccess": "نجح التذكير",
  "RemindShip": "تذكير بالشحن",
  "remind": "تذكير بالشحن",
  "remindTitle": "تذكير بالشحن",
  "tipsRemindsText": "بعد شحن المنتجات ، سيتلقى البائع إشعارًا بذلك",
  "remindContent": "بعد شحن المنتجات ، سيتلقى البائع إشعارًا مرة واحدة فقط",
  "tipsRemindsMerchant": "تذكير البائع",
  "days": "أيام)",
  "addCartMessage": "تمت الإضافة إلى عربة التسوق الخاصة بك بنجاح",
  "addAddress": "أضف عنوان جديد",
  "addAddressOrModifyAddress": "إضافة عنوان جديد / تغيير العنوان",
  "addCart": "أضف إلى عربة التسوق",
  "图片不得大于10M": "لا يمكن أن يكون حجم ملف الصورة أكبر من 10 ميجا",
  "图片不得大于2M": "لا يمكن أن يكون حجم ملف الصورة أكبر من 2 ميغا",
  "图片大小不能超过2M！": "حجم الملف للصورة لا يمكن أن يتجاوز 2M!",
  "图片上传失败": "فشل تحميل الصورة",
  "recommendclass": "تسوق حسب الاقسام",
  "recommend": "يوصي",
  "recommendedProducts": "العناصر الشعبية",
  "recommendedStore": "المتاجر الشعبية",
  "推荐码不正确": "كود التوصية خاطئ",
  "推荐人无权限推荐": "لا توجد سلطة للتوصية",
  "推荐商品": "العناصر الشعبية",
  "logout": "تسجيل خروج",
  "returnsAndEx": "الإرجاع والاستبدال",
  "returnAmount": "المبلغ العائد",
  "returnRemark": "تعليمات الإرجاع",
  "returnPolicy": "سياسة العائدات",
  "Refund": "استرداد",
  "refund": "رد الأموال / ما بعد البيع",
  "退款成功": "نجح رد الأموال",
  "refundSuccessfully": "نجح رد الأموال",
  "refundSuccess": "نجح رد الأموال",
  "returnReason": "سبب الاسترداد",
  "returnApply": "طلب ارجاع",
  "退款失败": "فشل الاسترداد",
  "refundFail": "فشل الاسترداد",
  "refundInstructions": "تعليمات الاسترداد",
  "refunding": "جاري استرداد الأموال",
  "mastercard": "بطاقة ماستر بطاقة ائتمان",
  "EsShop": "متجر على الانترنت",
  "ForgotPassword": "نسيت كلمة المرور؟",
  "委托数量(张)必填": "الكمية المؤتمنة (قطعة) مطلوبة",
  "委托数量(张)不能小于等于0": "لا يمكن أن تكون الكمية الموكلة (قطعة) أقل من أو تساوي 0",
  "foryourmoney": "القروض عبر الإنترنت هي خيار مناسب وسريع لحل مشاكلك المالية. لن تشعر بالحرج عندما تقترض المال من الأصدقاء. سيساعدك فريقنا المحترف على متابعة العملية وإزالة شكوكك في أي وقت. نهدف إلى منح عملائنا كل قرض بسرعة وشفافية وأمان.",
  "storeSeachTips1": "ابحث عنك",
  "未绑定谷歌验证器": "لم يتم ربط Google Authenticator",
  "未绑定手机号": "لم يتم إضافة رقم الهاتف المحمول",
  "未绑定邮箱": "لم يتم إضافة البريد الإلكتروني",
  "未发现授权记录": "لم يتم العثور على سجل التفويض",
  "notQua": "لم تستوفِ المتطلبات",
  "ShippingAddressNotSet": "لم يتم تحديد عنوان الشحن",
  "未实名认证，是否认证？": "غير مصدق بالاسم الحقيقي. المصادقة؟",
  "cancelOrder1": "لم يتم استلام المنتج",
  "未授权访问": "دخول غير مرخص",
  "noRefund": "لم يتم ردها",
  "未找到符合条件的匹配订单": "لم يتم العثور على ترتيب مطابق",
  "未找到匹配的收益记录": "لم يتم العثور على سجل عائدات مطابق",
  "mine": "لي",
  "myloan": "القرض الخاص بي",
  "myOrder": "طلباتي",
  "myCart": "سلة التسوق الخاصة بي",
  "我的购物车": "سلة التسوق الخاصة بي",
  "myPurse": "محفظتى",
  "myAccount": "حسابي",
  "aboutText1": "نحن نقدم خدمات القروض على أساس فلسفة العمل الخاصة بالعميل أولاً ، والتي تهدف إلى حل مشاكل رأس المال المالية للعملاء. منذ تأسيس الشركة ، ساعدنا العديد من العملاء في حل مشاكل دوران رأس المال الخاصة بهم.",
  "readAndAgree": "لقد قرأت وقبلت",
  "safeInfo": "لا تتطلب رهنًا عقاريًا ولا إيداعًا ولا رد اتصال. إنها مسألة خاصة.",
  "无权限": "لا أذونات",
  "无效的UID": "UID غير صالح",
  "item": "غرض",
  "系统参数错误": "خطأ في معلمة النظام",
  "系统存在相同[系统登录名]！": "يوجد بالفعل مستخدم آخر في النظام بنفس اسم تسجيل الدخول",
  "系统错误，请稍后重试": "خطأ بالنظام. الرجاء معاودة المحاولة في وقت لاحق",
  "系统发货成功": "نجح",
  "系统默认好评": "مراجعات جيدة بشكل افتراضي",
  "defaultRate": "مراجعات جيدة بشكل افتراضي",
  "checkout": "ضع طلبية",
  "下单不能小于最小金额限制": "لا يمكن أن يكون مبلغ وضع الطلب أقل من الحد الأدنى",
  "下单成功，等待付款": "تم تقديم الطلب بنجاح ، ونحن في انتظار الدفع",
  "下单成功，付款成功": "نجح الدفع",
  "buyTips": "بعد تقديم الطلب ، سيتم شحنه في غضون 24 ساعة. يعتمد وقت الشحن على الخدمات اللوجستية وقد يطول. يرجى الانتباه إلى المعلومات اللوجستية أو الاتصال بخدمة العملاء.",
  "nextPage": "الصفحة التالية",
  "stateMent": "بيان العبودية الحديثة",
  "storeSeachTips2": "تم العثور على متاجر ذات صلة",
  "address": "عنوان تفصيلي",
  "items": "غرض",
  "browse": "إجمالي المبيعات",
  "sold": "مُباع",
  "sales": "إجمالي المبيعات",
  "校验IP不合法": "IP التحقق غير صالح",
  "new": "جديد",
  "newPassword": "كلمة المرور الجديدة",
  "新密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "新密码不一致": "كلمة المرور غير متطابقة",
  "新密码确认不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "news": "أخبار",
  "addNewAddress": "أضف عنوان جديد",
  "creditTit": "خدمة قرض الائتمان",
  "Information": "معلومة",
  "行情获取异常，稍后再试": "عرض الأسعار غير طبيعي ، يرجى المحاولة مرة أخرى لاحقًا",
  "modifyAddress": "تغيير العنوان",
  "handlingfee": "مطلوب رسوم الخدمة",
  "Opt": "يختار",
  "selectDeliveryAddress": "اختر عنوان الشحن",
  "验证类型不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "验证码不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "验证码不正确": "رمز التحقق غير صحيح",
  "验证码错误": "خطأ في رمز التحقق",
  "vcodeFail": "فشل التحقق ، يرجى المحاولة مرة أخرى",
  "vcodePass": "تم التحقق!",
  "invitationCode": "شفرة الدعوة",
  "页码不能小于等于0": "لا يمكن أن يكون رقم الصفحة أقل من أو يساوي 0",
  "页码不是整数": "رقم الصفحة ليس عددًا صحيحًا",
  "dashboard": "لوحة القيادة",
  "loaned": "معار",
  "loanDays": "مدة",
  "已发货，正在运输中": "تم الشحن في النقل",
  "followed": "يتبع",
  "repaid": "السداد",
  "已领取": "تلقى",
  "rated": "تمت المراجعة",
  "cancelled": "ألغيت",
  "confirmed": "مؤكد",
  "harvested": "تلقى",
  "mySold": "مُباع",
  "overdue": "متأخر",
  "privacyPolicy": "سياسة الخصوصية",
  "用户不存在": "المستخدم غير موجود",
  "用户名必须由数字和英文字母组成": "يجب أن يتكون اسم المستخدم من أرقام وحروف",
  "用户名不存在": "المستخدم غير موجود",
  "用户名不符合设定": "اسم المستخدم غير مطابق",
  "用户名不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "用户名参数为空": "لا يمكن أن يكون الحقل فارغًا",
  "用户名重复": "انسخ اسم المستخدم",
  "userEvaluation": "مراجعات المستخدم",
  "用户剩余数量不足": "عدد غير كافٍ من المستخدمين",
  "用户已跟随交易员": "يتابع المستخدم المتجر",
  "user_Center": "مركز المستخدم",
  "userReg": "تسجيل المستخدم",
  "postCode": "رمز بريدي",
  "orderEmail": "بريد إلكتروني",
  "邮箱已绑定": "تم بالفعل تقييد البريد الإلكتروني",
  "邮箱已绑定其他用户": "تم بالفعل ربط البريد الإلكتروني بمستخدم آخر",
  "orderPostCode": "رمز بريدي",
  "hasImage": "مع الصور",
  "Balance": "توازن",
  "balance": "الرصيد (USDT)",
  "余额不足": "رصيد غير كاف",
  "balanceNot": "الرصيد لا يكفي ، يرجى الإيداع",
  "cancelOrder8": "تفاوض على استرداد مع البائع",
  "expectedArrival": "وقت الوصول المتوقع",
  "esRepayment": "السداد المقدر",
  "estirepay": "السداد المقدر",
  "originPrice": "السعر الأصلي",
  "deliveryFee": "شحن",
  "goodsFreight": "شحن",
  "shippingDiscounts": "خصم الشحن",
  "homeIconTips3": "خصم الشحن",
  "desc6": "أدخل كلمة مرور المعاملة الخاصة بك مرة أخرى",
  "rebuy": "طلب آخر",
  "onlineService": "خدمات عبر الانترنت",
  "customeService": "خدمة العملاء عبر الإنترنت",
  "helpLine": "خدمة العملاء عبر الإنترنت",
  "onlineApplin": "يقدم طلب على الإنترنت",
  "暂无店铺": "لم يتم العثور على متجر",
  "noComments": "لا تعليقات حتى الآن",
  "noData": "لاتوجد بيانات",
  "帐户异常需要进行C3认证，请联系在线客服。": "يتطلب استثناء الحساب مصادقة C3. يرجى الاتصال بخدمة العملاء عبر الإنترنت.",
  "account": "حساب",
  "accountBalance": "رصيد الحساب",
  "accountB": "رصيد الحساب",
  "accountReview": "نظرة عامة على الحساب",
  "Recruitment": "وظائف",
  "找不到用户": "لم يتم العثور على المستخدم",
  "searchTips": "ابحث عن العلامات التجارية / المنتجات / الموردين",
  "discount": "الخصومات",
  "homeDownloadtips3": "خصومات بدون توقف",
  "discounted": "الخصومات",
  "actualName": "الاسم الكامل",
  "passPortImg": "رقم الهوية / جواز السفر",
  "uploadId": "تحميل الهوية / صورة جواز السفر",
  "Payment": "قسط",
  "pay": "قسط",
  "paymentSuccessful": "نجح الدفع",
  "paymentPending": "الدفع معلق",
  "paymentPendingDesc": "جارٍ معالجة الدفع الخاص بك. يرجى التحقق من حالة طلبك لاحقًا",
  "paymentMethod": "طرق الدفع",
  "paymethods": "طرق الدفع",
  "payCertificate": "شهادة دفع",
  "直线关系，不能修改推荐": "علاقة خط مستقيم ، لا يمكن تعديل التوصية",
  "tipsRemindsCount": "يمكن تذكيرها مرة واحدة فقط",
  "committed": "نحن ملتزمون بتقديم خدمات القروض لأصحاب المشاريع",
  "mediumOpinion": "متوسط الاستعراضات",
  "sort": "يكتب",
  "重复提交": "إعادة التقديم",
  "Reapply": "أعد التقديم",
  "register": "يسجل",
  "signUp": "يسجل",
  "registerSuccess": "نجح التسجيل",
  "转账币种不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "转账数量不能小于等于0": "لا يمكن أن يكون مبلغ التحويل أقل من أو يساوي 0",
  "orderStatus": "حالة",
  "orderState": "حالة",
  "状态不能小于0": "لا يمكن أن تكون الحالة أقل من 0",
  "状态不是整数": "الحالة ليست عددًا صحيحًا",
  "资金密码必须6-12位": "يجب أن تتكون كلمة مرور الصندوق من 6 إلى 12 حرفًا",
  "资金密码不符合设定": "كلمة مرور الصندوق غير متطابقة",
  "资金密码不能为空": "لا يمكن أن يكون الحقل فارغًا",
  "资金密码错误": "خطأ في كلمة مرور الصندوق",
  "资金密码长度不符合设定": "لا يتطابق طول كلمة المرور مع الإعدادات",
  "complex": "تلخيص",
  "totalOf": "المجموع",
  "totalPrice": "السعر الكلي",
  "homeBannertips3": "الأعلى.",
  "creditReview": "اجتياز التدقيق في ساعة واحدة على أقرب تقدير. إذا تم تمرير المراجعة ، فسيتم تحرير القرض على الفور.",
  "yesterday": "أمس",
  "binance": "Binance",
  "huobi": "Huobi",
  "validatorIpRule": "عنوان IP غير صحيح",
  "metaMask": "MetaMask",
  "footTip": "{name} Limited 2024. جميع الحقوق محفوظة.",
  "footTips": "{name} Limited هي شركة مرخصة ومنظمة من قبل هيئة السلوك المالي كوسيط ائتمان (713206) وتتعامل حصريًا مع جهة الإقراض Home Retail Group CardServices Limited باعتبارها MetaShop Financial Services. {name} الخدمات المالية مُرخصة ومنظمة من قبل هيئة السلوك المالي لتقديم الائتمان (716148). شركة Home Retail GroupCard Services Limited مسجلة في المملكة المتحدة (04007072) في Avebury، 489-499 Avebury Boulevard، Milton Keynes، United Kingdom. MK9 2NW.",
  "footdec": "يأتي مستخدمو موقع {name} العالمي من {num} دولة حول العالم ويستخدمون {coin} للمستوطنات. {coin} هي معاملة بلا حدود تتيح معاملات فورية منخفضة التكلفة حول العالم دون انتظار وفرض رسوم دولية.",
  "okx": "okx",
  "UID不能为空": "لا يمكن أن يكون المعرف الفريد فارغًا",
  "滑动验证": "اسحب شريط التمرير لإكمال اللغز",
  "头像选择": "اختر صورة",
  "修改头像": "يتغير",
  "银行卡": "بطاقة مصرفية",
  "平台人工发起退款": "رد الأموال التي بدأها النظام الأساسي",
  "最多上传9张图片": "تحميل ما يصل إلى 9 صور",
  "账号注销": "إلغاء الحساب",
  "确定注销": "تأكيد الالغاء",
  "您的账号": "الحساب الخاص بك",
  "为什么要离开": "لماذا تريد المغادرة",
  "您还有余额,不能注销账号": "لا يزال لديك رصيد ، لا يمكنك إلغاء حسابك!",
  "请输入注销理由": "الرجاء إدخال سبب الإلغاء",
  "您确认要注销吗?": "هل أنت متأكد أنك تريد إلغاء؟",
  "我再考虑下": "سأفكر بشأنه",
  "同意注销": "توافق على الإلغاء",
  "注销成功": "نجح الإلغاء",
  "请选择": "الرجاء التحديد",
  "提款地址绑定": "سحب عنوان ملزم",
  "绑定成功": "نجح الربط",
  "仅能绑定一个收款地址!": "يمكن ربط عنوان واحد فقط!",
  "加值": "إضافة قيمة",
  "提领": "انسحاب",
  "联系商家": "تواصل مع البائع",
  "最多包含10位小数": "يحتوي على ما يصل إلى 10 منازل عشرية",
  "企业电话": "هاتف العمل",
  "加密货币": "عملة مشفرة",
  "职业机会": "فرص عمل",
  "充值币种": "عملة الإيداع",
  "充值金额": "قيمة الايداع",
  '参数缺失': 'معلمة مفقودة',
  '充值数量必填': 'الكمية المدفوعة مطلوبة',
  "充值金额不得小于": "لا يمكن أن يكون مبلغ الإيداع أقل من",
  "充值金额不得大于": "لا يمكن أن يكون مبلغ الإيداع أكبر من",
  "请先选择币种": "الرجاء تحديد العملة أولاً",
  "开户行": "بنك",
  "请输入开户行名称": "الرجاء إدخال اسم البنك",
  "银行卡号": "رقم البطاقة المصرفية",
  "请输入银行卡号": "الرجاء إدخال رقم البطاقة المصرفية",
  "点击去支付": "انقر للدفع",
  "企业证明": "شهادة المؤسسة",
  "footTipTikTok": "CoveBuy © حقوق التأليف والنشر ️2024",
  "客户端下载":"تنزيلات العميل",
  "提现方式": "طريقة السحب",
  "长时间未付款，系统自动取消订单": "إذا لم يتم الدفع لفترة طويلة ، سيتم إلغاء الطلب تلقائيًا",
  "TikTokFoot": "CoveBuy هو منصة اجتماعية عالمية لمقاطع الفيديو القصيرة CoveBuy وأكبر شركة تجارة جملة في آسيا Alibaba ، تأسست بالتعاون. إنها منصة تجارة إلكترونية عالمية ولديها ثلاثة مستودعات ذكية ذاتية التشغيل في العالم ، وتقع في تورنتو ، كندا ، لوس أنجلوس ، وتشيبا ، اليابان. تشمل المنتجات المعروضة للبيع في التطبيق منتجات شهيرة من اليابان وكوريا الجنوبية والصين ودول آسيوية أخرى. في الوقت الحاضر ، تجاوز العدد الإجمالي 50،000 ويستمر في النمو بسرعة.",
  "cancelInfo": "تحذير! يرجى توخي الحذر لإلغاء الحساب. إذا لم تعد تستخدم الحساب ، يمكنك النقر فوق [Agree to Cancellation]. قد لا تتمكن من التسجيل في غضون أيام قليلة بعد الإلغاء.",
  "betaBannerText": "الموقع في الاختبار العام، يرجى عدم الطلب"
}